<div class="flex flex-col">
  <!--
    a11y: close (X) reordered to be FIRST in DOM (order-2 puts it visually
    on the trailing side, order-1 keeps the icon+heading on the leading
    side). [focusInitial]=true makes the CDK focus trap target it on open.
    Rendered on mobile too so every viewport satisfies the audit.
  -->
  <div class="flex justify-between mb-4">
    <mot-button matType="icon" icon="close"
      [ariaLabel]="closeButtonText"
      class="!border-none !w-min !h-min cursor-pointer !bg-transparent order-2" iconClass="!text-2xl"
      [focusInitial]="true"
      (onClick)="onClose.emit()" />
    <div class="flex items-center gap-2 order-1">
      <ng-icon [name]="'message-exclamation'" aria-hidden="true"></ng-icon>
      <h2 class="m-0 text-base font-normal">{{headLineText}}</h2>
    </div>
  </div>
  <app-special-messages-pop-up-list [messages]="messages" (onItemClicked)="onItemClicked.emit($event)" />
  @if (isDesktop) {
    <div class="!flex justify-end !sticky bottom-2 px-2">
      <mot-button [text]="closeButtonText"
        buttonClass="!bg-primary !w-4 !text-white !px-2 !py-3 !rounded-lg !align-middle mt-0.5"
        (onClick)="onClose.emit()" />
      </div>
    }
  </div>